import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { NativeStorage } from "@ionic-native/native-storage";
import { Platform } from "ionic-angular";

import firebase from "firebase/app";
import APP_CONFIG from '../../app-config/app-config';
import { AuthProvider } from "../providers/auth/auth";
import { MainService } from "./main.service";

@Injectable()
export class PageIndicatorsService {

	pageUpdateIndicatorData: any = {};

	private clinicalUpdateData: any = [];
	private pageIndicatorsSeen: any = {};

	constructor(
		private platform: Platform,
		private http: Http,
		private nativeStorage: NativeStorage,
		private authProvider: AuthProvider,
		private mainService: MainService,
	) {}

	init(): void {
		this.platform.ready().then(() => {
			// get clinical update version data
			this.http
				.get(this.mainService.dataDirectory('clinical-updates.json'))
				.map((res) => res.json())
				.subscribe((res) => {
					this.clinicalUpdateData = res;
					this.getPageUpdateIndicatorData();

					// if user auth status changes, get the data again
					this.authProvider.authChanged$.subscribe(() => {
						this.getPageUpdateIndicatorData();
					})
				});
		});
	}

	private refReplace(ref: string): string {
		// remove special characters from ref string (disallowed by firebase)
		let chars = '.#$/[]';
		return ref.replace(new RegExp(`[\\${chars.split('').join('\\')}]`, 'g'), '');
	}

	private getPageUpdateIndicatorData(): void {
		// if user is logged in, get the data from the database
		if(this.authProvider.loggedIn()) {
			firebase.database()
				.ref(`/userProfile/${firebase.auth().currentUser.uid}`)
				.child('pagesViewed').on('value', (res) => {
					this.pageIndicatorsSeen = res.val() || {};
					this.setPageUpdateIndicatorData();
				});
		// if user is not logged in, get the data from native storage
		}else if(this.platform.is('cordova')) {
			this.nativeStorage.getItem('pageIndicators').then((res) => {
				this.pageIndicatorsSeen = res || {};
				this.setPageUpdateIndicatorData();
			}, (error) => {
				// continue with no data
				this.setPageUpdateIndicatorData();
			});
		}else{
			this.setPageUpdateIndicatorData();
		}
	}

	private seenCurrentVersion(ref: string): boolean {
		ref = this.refReplace(ref);

		// check if the version that has been seen matches the current app version
		if(this.pageIndicatorsSeen[ref] && this.pageIndicatorsSeen[ref].version === APP_CONFIG.app_version) {
			return true;
		}

		return false;
	}

	private setPageUpdateIndicatorData(): void {
		let pages = {};

		// get all updates from the update data that match the current app version
		for(let i = 0; i < this.clinicalUpdateData.length; i++) {
			if(this.clinicalUpdateData[i].app_version && this.clinicalUpdateData[i].app_version === APP_CONFIG.app_version) {
				let ref = this.refReplace(this.clinicalUpdateData[i].cpg_reference);

				pages[ref] = {
					// check if the page has been seen by the user or not
					seen: this.seenCurrentVersion(ref)
				}
			}
		}

		this.pageUpdateIndicatorData = pages;
	}

	updatePageIndicator(ref: string): void {
		ref = this.refReplace(ref);

		if(!this.pageUpdateIndicatorData[ref]) {
			return;
		}
		
		// set the version of the page which has been seen
		this.pageIndicatorsSeen[ref] = { version: APP_CONFIG.app_version };

		// update the seen status of the indicator data
		this.pageUpdateIndicatorData[ref].seen = true;
		
		// update database with new data if the user is logged in
		if(this.authProvider.loggedIn()) {
			firebase.database()
				.ref(`/userProfile/${firebase.auth().currentUser.uid}`)
				.update({ 'pagesViewed': this.pageIndicatorsSeen });
		}

		// update native storage data if it is available
		if(this.platform.is('cordova')) {
			this.nativeStorage.setItem('pageIndicators', this.pageIndicatorsSeen);
		}
	}

	hasIndicator(ref: string): boolean {
		if(!ref) {
			return false;
		}

		ref = this.refReplace(ref);

		return this.pageUpdateIndicatorData[ref];
	}

	indicatorClass(ref: string): string {
		ref = this.refReplace(ref);

		if(ref && this.pageUpdateIndicatorData[ref] && this.pageUpdateIndicatorData[ref].seen) {
			return 'is-seen';
		}

		return '';
	}
	
}


// WEBPACK FOOTER //
// ./src/services/page-indicators.service.ts